module.exports = __webpack_public_path__ + "media/images/visa-11e2924e8d34aa71d1abeafd04d9bafc.svg";